import { gql } from '@apollo/client';

export const fetchWorkflowWebhooksQuery = gql`
  query getWorkflowWebhooks($pagination: Pagination, $search: String, $sort: Sort) {
    workflowWebhooks(pagination: $pagination, search: $search, sort: $sort) {
      results {
        id
        name
      }
    }
  }
`;

export const defaultVariables = {
  pagination: {
    limit: 50,
    offset: 0,
  },
  search: '',
  sort: {
    sortBy: 'UpdatedAt',
  },
};
